
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as CbMeasureIconComponent } from "./cb-measure-icon.svg";

export const CbMeasureIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <CbMeasureIconComponent {...props} />;
};
